import React, {
  RefObject,
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import useChartOptions from "../hooks/useChartOptions";


interface Props {
  children: React.ReactNode
}

export function ChartRefProvider({ children }: Props) {
  const { option } = useChartOptions()

  const chartRef = useRef<ChartRef | null>(null)
  const [chart, setChart] = useState<Chart>()

  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    setChart(chartRef.current.chartComponent.current.chart)
  }, [chartRef, children])

  useEffect(() => {
    chart?.removeCustomSectionBand?.()
  }, [option])

  return (
    <chartRefContext.Provider
      value={{
        chartRef,
        chart,
      }}
    >
      {children}
    </chartRefContext.Provider>
  )
}

export function useChartRef() {
  return useContext(chartRefContext)
}

const chartRefContext = createContext<{
  chartRef: RefObject<ChartRef | null>
  chart?: Chart
}>({
  chartRef: { current: null },
  chart: undefined,
})

type ChartRef = {
  chartComponent: {
    current: {
      chart: Chart
    }
  }
}

type Chart = {
  removeAnnotations?(): void
  removeCustomSectionBand?(): void
  get?(series: string): Series
}

type Series = {
  xData: number[]
  yData: number[] | number[][]
}
